import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { IApplicationState } from "@/store-redux";
import { ROUTES } from "@/constants";

const HomeRedirect: React.FC = () => {
  const navigate = useNavigate();
  const currentUser = useSelector((state: IApplicationState) => state.currentUser);

  useEffect(() => {
    if (currentUser?.data) {
      // User is logged in, redirect to dashboard
      navigate(ROUTES.LEARN, { replace: true });
    } else {
      // User is not logged in, redirect to login
      navigate(ROUTES.LOGIN, { replace: true });
    }
  }, [currentUser, navigate]);

  // Show loading while redirecting
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "18px",
      }}
    >
      Redirecting...
    </div>
  );
};

export default HomeRedirect;
